import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes } from "react-router-dom";
import AppRoute from './config/app-route.jsx';
import { Provider } from 'react-redux';
import { store } from './redux';
import * as serviceWorker from './serviceWorker';

// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.css';
import './scss/react.scss';


const container = document.getElementById('root');
const root = createRoot(container);

function App() {
	const routes= AppRoute();
	let element = useRoutes(routes);
	return element;
}

root.render(
	<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
  </Provider>
);
// Registra public/worker.js, que no cachea nada (solo hace la app instalable).
// Al ocupar el scope "/" reemplaza cualquier service worker viejo con caché que
// siguiera sirviendo un bundle desactualizado, y borra sus cachés al activarse.
serviceWorker.register();